import React from 'react';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuSeparator,
  DropdownMenuTrigger 
} from '../../ui/dropdown-menu';
import { 
  Eye, 
  Edit, 
  Download, 
  Trash2, 
  Settings, 
  RefreshCw, 
  MoreHorizontal,
  ExternalLink,
  Copy,
  Archive,
  Star
} from 'lucide-react';
import { cn } from '../../../lib/utils';
import './ShadcnActionDropdown.css';

const ShadcnActionDropdown = ({
  actions = [],
  size = 'medium',
  variant = 'default',
  disabled = false,
  className = '',
  triggerIcon = null,
  triggerText = null,
  isImageCard = false,
  align = 'end'
}) => {
  const getIconComponent = (iconName) => {
    const iconMap = {
      'view': <Eye className="h-4 w-4" />,
      'edit': <Edit className="h-4 w-4" />,
      'delete': <Trash2 className="h-4 w-4" />,
      'download': <Download className="h-4 w-4" />,
      'settings': <Settings className="h-4 w-4" />,
      'refresh': <RefreshCw className="h-4 w-4" />,
      'more': <MoreHorizontal className="h-4 w-4" />,
      'external': <ExternalLink className="h-4 w-4" />,
      'copy': <Copy className="h-4 w-4" />,
      'archive': <Archive className="h-4 w-4" />,
      'star': <Star className="h-4 w-4" />
    };
    return iconMap[iconName] || null;
  };

  const renderTrigger = () => {
    if (triggerIcon) {
      return triggerIcon;
    }
    
    if (triggerText) {
      return <span>{triggerText}</span>;
    }

    return <MoreHorizontal className="h-4 w-4" />;
  };

  const getTriggerClasses = () => {
    const baseClasses = "shadcn-dropdown-trigger";
    
    const sizeClasses = {
      small: "small",
      medium: "medium",
      large: "large"
    };

    const variantClasses = {
      default: "default",
      primary: "primary",
      secondary: "secondary",
      outline: "outline"
    };

    const imageCardClasses = isImageCard ? "image-card" : "";

    return cn(
      baseClasses,
      sizeClasses[size],
      variantClasses[variant],
      imageCardClasses,
      className
    );
  };

  const getMenuItemClasses = (action) => {
    const baseClasses = "shadcn-dropdown-item";
    
    if (action.danger) {
      return cn(baseClasses, "danger");
    }
    
    return baseClasses;
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger 
        asChild
        disabled={disabled}
      >
        <button
          className={getTriggerClasses()}
          title={isImageCard ? "Image Actions Menu" : "Actions"}
        >
          {renderTrigger()}
        </button>
      </DropdownMenuTrigger>
      
      <DropdownMenuContent 
        align={align}
        className={cn(
          "shadcn-dropdown-content",
          isImageCard && "image-card"
        )}
      >
        {actions.map((action, index) => (
          <React.Fragment key={index}>
            {action.separator && index > 0 && <DropdownMenuSeparator className="shadcn-dropdown-separator" />}
            <DropdownMenuItem
              className={getMenuItemClasses(action)}
              onClick={() => !action.disabled && action.onClick && action.onClick()}
              disabled={action.disabled}
            >
              {action.icon && (
                <span className="shadcn-dropdown-item-icon">
                  {typeof action.icon === 'string' ? getIconComponent(action.icon) : action.icon}
                </span>
              )}
              <span className="shadcn-dropdown-item-label">{action.label}</span>
            </DropdownMenuItem>
          </React.Fragment>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ShadcnActionDropdown;
